import type * as monaco from 'monaco-editor'

export const FPlusLanguageConfiguration: monaco.languages.LanguageConfiguration =
  {
    brackets: [
      ['{', '}'],
      ['[', ']'],
      ['(', ')'],
      ['"', '"'],
      ["'", "'"],
    ],
    colorizedBracketPairs: [
      ['{', '}'],
      ['[', ']'],
    ],
    indentationRules: {
      increaseIndentPattern: /^(\s*)(if|else|in|when|let|import|assert|then)/g,
      indentNextLinePattern: /^([^=]*=\s*$)|(.*->\s*$)/g, // NOSONAR -> This is only parsing data from the configuration and not user input/data as such vulnerability due to backtracking is not a concern
      decreaseIndentPattern: /^(\s*)(in|then|else)/g,
    },
    folding: {
      markers: {
        start: /^let|import|assert|\{/g,
        end: /^in|\}/g,
      },
    },
  }
